(function () {
    "use strict";

    Directives.CompanyTeamDirective =  function CompanyTeamDirective() {

        // @ngInject
        function CompanyTeamDirectiveControllerCtor($scope, $injector, $filter, AnalyticsService, UsersManager, CompaniesManager, CompanyService, PopupMessageService, PendingTasksManager, Enums) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'CompanyTeamDirectiveController';

            this.CompanyService = CompanyService;
            this.CompaniesManager = CompaniesManager;
            this.PopupMessageService = PopupMessageService;
            this.companyPermissionTypes = CompanyService.getCompanyPermissionTypes();
            this.PendingTasksManager = PendingTasksManager;
            this.AnalyticsService = AnalyticsService;

            this.company = CompaniesManager.getCurrCompany();
            this.currUser = UsersManager.getCurrUser();
            this.isAdmin = this.currUser.hasCompanyAdminPermissions();
            this.notificationTypesEnum = Enums.CompanyOwnerNotificationTypes;
            if (angular.isDefined(this.company.owner))
            {
                this.isOwner = this.company.owner._id === this.currUser._id;
                this.hasTeamMembers = this.company.doesCurrUserHaveTeamMembers();
            }

            this.notificationTypes = [];
            angular.forEach(this.notificationTypesEnum, function(value, key) {
                this.push(
                    {text: value,
                        isOn: false,
                        type: key});
            }, this.notificationTypes);
            this.updateNotifications($filter);

            this.company.once('success', function gotCompany() {
                this.isAdmin = this.currUser.hasCompanyAdminPermissions();
                this.isOwner = this.company.owner._id === this.currUser._id;
                this.hasTeamMembers = this.company.doesCurrUserHaveTeamMembers();
                this.updateNotifications($filter);
            }, this);

            this.addTeamMembers = function addTeamMembers() {
                this._openAddTeamMembers();
            };

            this.companyDataViewModel = {};

            this.CompaniesManager.getCompanyAdditionalInfo(this.company).then(function getCompanyPrivateFields(res) {
                this.companyDataViewModel = res.data;
            }.bind(this));
        }

        var CompanyTeamDirectiveController = Class(Controllers.BaseController, {
            constructor: CompanyTeamDirectiveControllerCtor,

            _openAddTeamMembers: function addTeamMembers() {
                var self = this;
                // should handle result here, since this is called from a few places in this file
                this.CompanyService.editTeamMembers(this.company, this.company.users).then(
                    function success() {
                        //TODO
                    }
                );
            },

            getUserCompanyPermission: function getUserCompanyPermission(user) {
                return this.CompanyService.getCompanyPermissionForUser(this.company, user);
            },

            setUserCompanyPermission: function setUserCompanyPermission(user, permission) {
                this.CompaniesManager.saveUserCompanyPermission(this.company, user, permission.name);
            },

            toggleNotification: function toggleNotification(index) {
                var NotificationObj = this.notificationTypes[index];
                this.company.setNotificationStatus(NotificationObj.type, NotificationObj.isOn);
            },

            updateNotifications: function updateNotifications($filter){
                var self = this;
                if (angular.isDefined(this.company.company_owner_notifications)){
                    angular.forEach(this.company.company_owner_notifications, function(notification) {
                        var found =  $filter('filter')(self.notificationTypes, {type: notification.notification_type_cd.toString()},true);
                        if (angular.isDefined(found) && found.length >0) {
                            found[0].isOn = notification.is_notification_on;
                        }
                    });
                }
            },

            toggleShareTeamCalendar: function toggleShareTeamCalendar() {
                if(!this.company.company_settings){
                    this.company.company_settings = {};
                }
                this.CompaniesManager.saveCompanySettings(this.company); //Error handling for now is just the glitch notification on the top right
            },


            deleteUserFromTeam: function deleteUserFromTeam(user) {
                this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                    'You are about to remove ' + user.email + ' from company team. All workspaces, files and sessions will be reassigned to company owner',
                    function clickedYeah() {
                        this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.confirm_team_member_removal);
                        this.removeUserFromTeamConfirmed(user);
                    }.bind(this),
                    function clickedNay(){
                        this.AnalyticsService.trackCancel(this, this.AnalyticsService.analytics_events.not_confirm_team_member_removal);
                    }.bind(this)
                );
            },

            removeUserFromTeamConfirmed: function removeUserFromTeamConfirmed(user) {
                var self = this;

                self['deleting' + user._id] = true;
                var taskData = {
                    company_id: self.currUser.company._id,
                    member_id: user._id,
                    performing_user_id: this.currUser._id
                };

                //we save the promise so that the polling could be canceled once we destroy the button. the promise is the token to stop the polling
                self.pendingTaskPromise = self.PendingTasksManager.createPendingTask(self.PendingTasksManager.pendingTasksTypes.removeTeamMember, taskData);
                self['deleting' + user._id] = true;

                return self.pendingTaskPromise.then(
                    function success(resp) {
                        // self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.info, "User removed");
                        self['deleting' + user._id] = false;
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.remove_team_member_success, taskData);

                        self.company = self.CompaniesManager.getCurrCompany();
                        if (angular.isDefined(self.company.owner))
                        {
                            self.hasTeamMembers = self.company.doesCurrUserHaveTeamMembers();
                        }
                    })
                    .catch(function fail(resp) {
                        self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.error, resp);
                        self.AnalyticsService.trackError(self, self.AnalyticsService.analytics_events.remove_team_member_error, resp);
                    })
                    .finally(function finallyHandler() {
                        self['deleting' + user._id] = false;
                    });
            },

            updateCompanyData: function updateCompanyData() {
                this.AnalyticsService.track(this.$scope, this.AnalyticsService.analytics_events.company_additional_data_updated, this.companyDataViewModel);
                this.CompaniesManager.updateCompanyAdditionalInfo(this.company, this.companyDataViewModel);
            }
        });

        return {
            scope:{},
            templateUrl : 'angular/app/modules/core/features/settings/company/team/company_team_directive_template.html',
            controller : CompanyTeamDirectiveController,
            controllerAs : 'companySettingsTeamVm',
            bindToController : true
        };

    };
}());
